import { format } from 'libs/dates'

export const toCouponPayload = (data: any) => ({
	code: data.code,
	price_discount: {
		value: data.price_discount_value,
		is_percentage: data.price_discount_is_percentage as boolean
	},
	valid_from: format(data.valid_from, 'yyyy-MM-dd'),
	valid_until: format(data.valid_until, 'yyyy-MM-dd'),
	is_active: !!data.is_active,
	booth_type: data.booth_type ?? null,
	rental: data.rental ?? null,
	max_uses: data.max_uses ?? null,
	booking_window_start: format(data.booking_window_start, 'yyyy-MM-dd'),
	booking_window_end: format(data.booking_window_end, 'yyyy-MM-dd')
})
